import { NpTestPlanCondition } from './npTestPlanTypes'

/**
 * Ids are LyraTherapy's `BatteryCondition` values. `usesGradeLevel` mirrors the imported batteries:
 * only the psychoeducational ones have measures with a grade range, the only ones `grade_level` narrows.
 */
export const NP_TEST_PLAN_CONDITIONS: NpTestPlanCondition[] = [
  { id: 'adhd', name: 'ADHD', usesGradeLevel: false },
  { id: 'asd', name: 'ASD', usesGradeLevel: false },
  { id: 'combination', name: 'ADHD - ASD', usesGradeLevel: false },
  { id: 'psychoeducational', name: 'Psychoed', usesGradeLevel: true },
  {
    id: 'general_neuropsych',
    name: 'Neuropsychological Testing (IQ + additional cognitive areas)',
    usesGradeLevel: false,
  },
  { id: 'tbi', name: 'TBI', usesGradeLevel: false },
  { id: 'mci_aging_dementia', name: 'MCI', usesGradeLevel: false },
]
